// extracted by mini-css-extract-plugin
export default {"header":"index_header_9uEnt","user":"index_user_VvxpS"};